import { useTranslation } from "react-i18next";
import { ReDirectToeKMC2 } from "../components/ReDirectToeKMC2";
import { stickyHeaderStyle, WaterSupplyLeftNavsList } from "../utils/constants";
import { CommonPageUiLayer } from "../components/CommonPageUiLayer";
import { scrollContainerStyle } from "../components/TableStructure";

const AssessmentCollectionCenters = [
  {
    office: "Cossipur Section, 10, B.T. Road, Kolkata-700002 Ph: 2558 8553",
    wards: "1,2,3,4,5,6",
    officer: "Asstt. Engineers",
    timing: "From 7-30 to 11-00 A.M.",
  },
  {
    office:
      "Hatibagan Section, 79, Bidhan Sarani, Kolkata-700006 Ph: 2543 1602",
    wards: "7,8,9,10,11,12,15",
    officer: "Do",
    timing: "Do",
  },
  {
    office:
      "Brindaban Bose Section, 28, Brindaban Bose Lane, Kolkata-700006, KMC Building",
    wards: "16,17,18,19,20",
    officer: "Do",
    timing: "Do",
  },
  {
    office:
      "B. K. Pal Section, 105, B. K. Pal Avenue (Near the B.K. Pal Park), Kolkata-700005",
    wards: "21,22,23,24,25",
    officer: "Do",
    timing: "Do",
  },
  {
    office: "Hedua Section, 6, Azad Hind Bagh, Hedua Square, Kolkata-700006",
    wards: "26,27,28,38,39",
    officer: "Do",
    timing: "Do",
  },
  {
    office:
      "Section (Maniktala), 109, Narkeldanga Main Road, Kolkata-700011 Ph: 2364 9252",
    wards: "13,14,29,30,31,32,33,34,35",
    officer: "Do",
    timing: "Do",
  },
  {
    office:
      "Section 'E', 1, Neel Madhab Sen Lane (Near Md. Ali Park), Kolkata-700011",
    wards: "41,42,43,44,45",
    officer: "Do",
    timing: "Do",
  },
  {
    office:
      "Section 'F', 22, Surya Sen Street, Kolkata-700012 (Near Borough V Office) Ph: 2219 2399",
    wards: "36,37,40,48,49,50",
    officer: "Do",
    timing: "Do",
  },
  {
    office: "Section 'G', 23, Princep Street, Kolkata-700072",
    wards: "46,47,51",
    officer: "Do",
    timing: "Do",
  },
  {
    office: "Section 'H', Hazi Md. Mohsin Square (Goltalab), Kolkata-700016",
    wards: "52,53,61,62,63",
    officer: "Do",
    timing: "Do",
  },
  {
    office:
      "Section 'I', 13, Dilkhusha Street (Near Park Circus Tram Depot), Kolkata-700017",
    wards: "64,65",
    officer: "Do",
    timing: "Do",
  },
  {
    office:
      "Section 'J', P-65, Dr. Sundari Mohan Avenue, Kolkata-700014 KMC Office",
    wards: "54,55,56,57,58,59,60",
    officer: "Do",
    timing: "Do",
  },
  {
    office:
      "Picnic Garden, 105/2, Prasanna Naskar Lane (Near Colony Bazar), Kolkata-700039 Ph: 2334 3900",
    wards: "66,67",
    officer: "Do",
    timing: "Do",
  },
  {
    office:
      "Section 'K', 212, Rashbehari Avenue (Gariahat Market, 3rd Floor), Kolkata-700025",
    wards: "68,69,72,84,85,86,87,90",
    officer: "Do",
    timing: "Do",
  },
  {
    office:
      "Section 'L', 125, Hazra Road (Hazra Road & Harish Mukherjee Road Crossing), Kolkata-700026 Ph: 2455 7978",
    wards: "70,71,73,74,82,83,88",
    officer: "Do",
    timing: "Do",
  },
  {
    office:
      "Section 'M', 39, Circular Garden Reach Road (Sudhi Bose Road Junction), Kolkata-700024",
    wards: "75,76,77,78,79,80",
    officer: "Do",
    timing: "Do",
  },
  {
    office:
      "Section 'Tollygunge', Opposite Golf Green Daily Market, Uday Sankar Sarani, Kolkata-700045 Ph: 2483 6604",
    wards: "81,89,91,92,93,94,95,96,97,98,99,100",
    officer: "Do",
    timing: "Do",
  },
  {
    office: "97 & 98, Garfa Main Road, Borough-XII Office, Kolkata-700075",
    wards: "103,104,105,106,107,108,109",
    officer: "Do",
    timing: "Do",
  },
  {
    office:
      "Baghajatin Market Complex, Unit-III, Baghajatin Station Road, Kolkata-700086",
    wards: "101,102,110,111,112,113,114",
    officer: "Do",
    timing: "Do",
  },
  {
    office:
      "S.S. Unit, Behala, 516, D.H. Road, Borough-XIII & XIV Office, Kolkata-700034",
    wards: "115,116,117,118,119,120,121,122,127,128,129,130,131,132",
    officer: "Do",
    timing: "Do",
  },
  {
    office:
      "G.R. Unit, E/3, Circular Garden Reach Road, Borough-XV Office, Kolkata-700024",
    wards: "133,134,135,136,137,138,139,140,141",
    officer: "Do",
    timing: "Do",
  },
  {
    office: "Br. XVI Office, Joka",
    wards: "123,124,125,126,142,143,144",
    officer: "Do",
    timing: "Do",
  },
];

const WaterSupplyZones = [
  {
    zone: "North",
    address: "79, Bidhan Sarani, Kolkata-700006",
    phone: "2543-1602",
    wards: "1-12,15-28,38-39",
    officer: "Executive Engineer",
  },
  {
    zone: "Central",
    address: "5, S.N. Banerjee Rd., Kolkata-700013",
    phone: "2286-1000 to 08, Ext. 2524",
    wards: "13-14,29-37,40-65",
    officer: "Do",
  },
  {
    zone: "South",
    address: "Poddar Nagar, 135, Prince Anwar Shah Rd., Kolkata-700068",
    phone: "2413-2232",
    wards: "81-89,91-100",
    officer: "Do",
  },
  {
    zone: "West",
    address: "212, Rash Behari Avenue, Kolkata-700025",
    phone: "2440-2793",
    wards: "66-80,82-88,90",
    officer: "Do",
  },
  {
    zone: "Jadavpur Unit",
    address: "97, 98 Garfa Main Rd., Kolkata-700075",
    phone: "2418-0645",
    wards: "101-114",
    officer: "Do",
  },
  {
    zone: "S.S. Unit",
    address: "516, D.H. Rd., Near S.B.I., Kolkata-700034",
    phone: "2397-0135 Extn Water Supply",
    wards: "115-132",
    officer: "Do",
  },
  {
    zone: "Garden Reach Unit",
    address: "E-3, C.G.R. Rd. (Near Hindusthan Lever), Kolkata-700024",
    phone: "2469-3283",
    wards: "133-141",
    officer: "Do",
  },
];

const Table = ({ headerList, dataList, columns, t, stickyHeader = false }) => (
  <table className="table table-bordered">
    <thead>
      <tr className="table-warning table-bor-2">
        {headerList.map((header, index) => (
          <th
            key={index}
            scope="col"
            style={stickyHeader ? stickyHeaderStyle : {}}
          >
            {t(header)}
          </th>
        ))}
      </tr>
    </thead>

    <tbody>
      {dataList.map((row, rowIndex) => (
        <tr key={rowIndex}>
          {columns.map((column, colIndex) => (
            <td key={colIndex}>
              {column.translate ? t(row[column.key]) : row[column.key]}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

const Water_Supply = () => {
  const { t } = useTranslation();
  return (
    <CommonPageUiLayer
      imgSrc={"assets/img/Banner/portal-banner6.jpg"}
      leftNavsList={WaterSupplyLeftNavsList}
      isLeftNavsListLong={true}
    >
      <div className="container">
        <div className="">
          <div className="inner-title2">
            <h3 className="fontSizeClass"> {t("Water Supply")} </h3>
          </div>

          <div id="accordion">
            <p className="fontSizeClass card-body font-weight-bold">
              {t(
                "Information sheet regarding generation of water supply showing the list of plants, reservoirs and Boosting stations."
              )}
            </p>
            <div className="card">
              <div className="card-header" id="heading5">
                <button
                  className="btn btn-link fontSizeClass  m-2"
                  data-toggle="collapse"
                  data-target="#collapse5"
                  aria-expanded="true"
                  aria-controls="collapse5"
                >
                  {t(
                    "Information sheet for how to get water supply connection in buildings "
                  )}
                  <i className="bi bi-arrow-right" />
                </button>
              </div>
              <div id="collapse5" className="collapse" data-parent="#accordion">
                <div className="card-body m-3 fontSizeClass">
                  <p>
                    {t("Different steps for getting water supply connection")}
                  </p>
                  <ol>
                    {[
                      "Contact to Assistant Engineer of the Local Office of Water Supply Department.",
                      "List of Plumbers will be available from them.",
                      "Select a plumber and the plumbers prepare the estimate. The user apply in the prescribed format and placed before Assistant Engineer for sanction.",
                      "After sanction deposit the amount and get connection.",
                    ].map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ol>
                  <p>
                    Fees includes Deposit money, Water charges, Connection fees,
                    Road opening fees, Road restoration fees etc.
                  </p>
                  <p>
                    One premises entitled to get one Water Supply Connection.
                  </p>
                  <p>
                    If any premises wants to take more water they may contact
                    Executive Engineer(Water Supply) of the respective Zone for
                    water supply through <strong>Bulk Meter</strong>.
                  </p>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-header" id="heading7">
                <button
                  className="btn btn-link fontSizeClass m-2"
                  data-toggle="collapse"
                  data-target="#collapse7"
                  aria-expanded="true"
                  aria-controls="collapse7"
                >
                  {t("1. For not getting water ")}
                  <i className="bi bi-arrow-right" />
                </button>
              </div>
              <div id="collapse7" className="collapse" data-parent="#accordion">
                <div className="card-body m-3 fontSizeClass">
                  <p className="fontSizeClass">
                    {t(
                      "For not getting water - Complaint is required to contact the corresponding office of his/her locality as mentioned below:-"
                    )}
                  </p>
                  <div
                    className="mayor-table2 depart"
                    style={scrollContainerStyle}
                  >
                    <Table
                      headerList={[
                        "Name of local water supply",
                        "Ward No",
                        "Officers concerned",
                        "Time",
                      ]}
                      dataList={AssessmentCollectionCenters}
                      t={t}
                      stickyHeader
                      columns={[
                        { key: "office" },
                        { key: "wards" },
                        { key: "officer" },
                        { key: "timing" },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="heading8">
                <button
                  className="btn btn-link fontSizeClass  m-2"
                  data-toggle="collapse"
                  data-target="#collapse8"
                  aria-expanded="true"
                  aria-controls="collapse8"
                >
                  {t("2. Special supply by water tanker ")}
                  <i className="bi bi-arrow-right" />
                </button>
              </div>
              <div id="collapse8" className="collapse" data-parent="#accordion">
                <div className="card-body m-3 fontSizeClass">
                  <ReDirectToeKMC2 label="Water Tanker Booking" />
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="heading9">
                <button
                  className="btn btn-link fontSizeClass  m-2"
                  data-toggle="collapse"
                  data-target="#collapse9"
                  aria-expanded="true"
                  aria-controls="collapse9"
                >
                  {t(
                    "3. Any other complaint on water supply including contamination"
                  )}
                  <i className="bi bi-arrow-right" />
                </button>
              </div>
              <div id="collapse9" className="collapse" data-parent="#accordion">
                <div className="card-body m-3 fontSizeClass">
                  <p className="fontSizeClass">
                    {t(
                      "Report may be lodged at the local water supply office mentioned above or K.M.C. Control Room during odd hrs. :- Tel. Numbers and address of the K.M.C. water supply zonal offices."
                    )}
                  </p>
                  <div className="mayor-table2 depart">
                    <Table
                      headerList={[
                        "Name of Zonal water supply office",
                        "Address",
                        "Ph. No",
                        "Ward No",
                        "Officer concerned",
                      ]}
                      dataList={WaterSupplyZones}
                      t={t}
                      columns={[
                        { key: "zone", translate: true },
                        { key: "address" },
                        { key: "phone" },
                        { key: "wards" },
                        { key: "officer" },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="heading8">
                <button
                  className="btn btn-link fontSizeClass  m-2"
                  data-toggle="collapse"
                  data-target="#collapse10"
                  aria-expanded="true"
                  aria-controls="collapse10"
                >
                  {t(
                    "4. For Small Diameter Tubewell, contact Executive Engineer, Tubewell Department..."
                  )}
                  <i className="bi bi-arrow-right" />
                </button>
              </div>
              <div
                id="collapse10"
                className="collapse"
                data-parent="#accordion"
              >
                <div className="card-body m-3 fontSizeClass">
                For <strong>Small Diameter Tubewell</strong>, contact Executive Engineer, Tubewell Department, 2nd Floor, 5, S. N. Banerjee Road, Kolkata – 700013, Phone: 2286-1000, Ext. 2567.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CommonPageUiLayer>
  );
};

export default Water_Supply;
